import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center p-4">
      <div className="text-center max-w-md">
        <div className="text-8xl font-black text-brand-500 mb-4">404</div>
        <h1 className="text-2xl font-bold text-neutral-900 mb-2">Page not found</h1>
        <p className="text-neutral-500 mb-8">The page you're looking for doesn't exist or has been moved.</p>
        <div className="flex justify-center gap-4">
          <Link to="/" className="px-6 py-3 bg-brand-500 text-white rounded-full font-bold hover:bg-brand-600 transition">Go Home</Link>
          <Link to="/login" className="px-6 py-3 border border-neutral-200 rounded-full font-medium hover:bg-neutral-50 transition">Sign In</Link>
        </div>
      </div>
    </div>
  );
}
